export const STATUS_SHOWS = {
    ACTIVE_SHOWS: 'activeShows',
    ARCHIVED_SHOWS: 'archivedShows',
    GUEST_SHOWS: 'guestShows',
} as const;
export type StatusShows = typeof STATUS_SHOWS[keyof typeof STATUS_SHOWS];
